import { ConditionAction } from '@/types/automationFields.ts';
import type { ConditionalDataOutput } from '@/types/automationSteps.ts';

type ConditionActionOption = {
  label: string;
  value: ConditionAction;
  disabled?: boolean;
};

const BASE_OPTIONS: ConditionActionOption[] = [
  { label: 'Run Child Steps', value: ConditionAction.ChildSteps },
  { label: 'Raise an Error', value: ConditionAction.RaiseError },
  { label: 'Return a Dataset', value: ConditionAction.ReturnDataset },
];

export const canMarkAllOutputsUnavailable = (outputs: ConditionalDataOutput[]) =>
  outputs.length > 0 && outputs.every((output) => output.may_be_unavailable === true);

export const getConditionActionOptions = (canMarkOutputsUnavailable: boolean): ConditionActionOption[] => [
  ...BASE_OPTIONS,
  {
    label: 'Mark All Outputs Unavailable',
    value: ConditionAction.Skip,
    disabled: !canMarkOutputsUnavailable,
  },
];
